import { Button } from '@chakra-ui/react';
import CouponDrawer from '@containers/checkout/popups/coupon.drawer';
import { fetchCoupons } from '@containers/checkout/queries';
import useOrder from '@hooks/useOrder';
import usePopup from '@hooks/usePopup';
import { useTranslation } from 'react-i18next';
import { FaExclamationCircle } from 'react-icons/fa';
import { RiCoupon2Line } from 'react-icons/ri';
import { setComma } from 'utils/common';

export default function CouponApplication() {
  const { t } = useTranslation('store');
  const { data } = fetchCoupons();
  const { order } = useOrder();
  const { openPopup } = usePopup();
  if (!order.cart) return <></>;
  const isUsable = data && data.length > 0;
  const onCouponPopup = () => {
    openPopup({
      isOpen: true,
      id: 'coupon-popup',
      props: { coupons: data, currentCoupon: order.coupon?._id },
      type: 'drawer',
      popupOptions: { placement: 'bottom' },
      Component: CouponDrawer,
    });
  };

  return (
    <div className="bg-white rounded-md shadow-sm px-2 py-4 w-full">
      <div className="flex items-center justify-center gap-[6px]">
        <div>
          <RiCoupon2Line size="18px" />
        </div>
        <span className="font-bold text-lg">COUPON</span>
      </div>
      <div>
        {isUsable ? (
          <div>
            {order?.coupon ? (
              <div className="bg-white shadow-md rounded-lg overflow-hidden cursor-pointer">
                <div className="px-6 py-4">
                  <h3 className="text-lg font-bold text-gray-800 mb-2">
                    {order.coupon.description}
                  </h3>
                  {/* <p className="text-gray-600">{order.coupon.description}</p> */}
                  <p className="text-gray-600 font-bold text-2xl mt-4">
                    <span className="text-blush-500">
                      {setComma(order.coupon.amount)}
                    </span>{' '}
                    Discount
                  </p>
                </div>
                <div
                  className="bg-primary-700 px-6 py-4 text-right"
                  onClick={onCouponPopup}
                >
                  <p className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded">
                    {t('change_coupon')}
                  </p>
                </div>
              </div>
            ) : (
              <div className="w-full flex items-center justify-center flex-col gap-2">
                <div>
                  <FaExclamationCircle color="#777" size="32" />
                </div>
                <p className="text-blush-500 font-bold">
                  {t('available_coupons')}
                </p>
                <Button
                  className="primary-button-sm w-full"
                  onClick={onCouponPopup}
                >
                  {t('apply_coupon')}
                </Button>
              </div>
            )}
          </div>
        ) : (
          <div className="items-center justify-center">
            <p className="text-zinc-400 text-center">
              {t('no_available_coupons')}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
